// extracted by mini-css-extract-plugin
module.exports = {"mapSection":"MapSection_mapSection__NOIe9"};